import cn from 'classnames';
import { useState } from 'react';
import { IWarehouse, IWarehouseWithBags, WarehouseTypes } from '@@/warehouses/ts';
import { IBag } from '@@/bags/ts';
import { Loader } from '@consta/uikit/Loader';
import { Collapse } from '@consta/uikit/Collapse';
import { FilledBag } from '@widgets/storage-viewer/bags-list/bag-filled';
import { WAREHOUSES_TYPES_ICON_DICTIONARY } from '@@/warehouses/dictionaries/types.dictionary';
import { WarehouseTypeTag } from '@@/warehouses/components/WarehouseTypeTag';

import styles from './index.module.sass';

export function WarehouseWithBagsCollapse(props: IWarehouseWithBagsCollapseProps) {
  const { className, warehouse, bagFilter, onLoadBags, onSelectBag } = props;
  const rootClass = cn(className, styles.root);
  const Icon = WAREHOUSES_TYPES_ICON_DICTIONARY[warehouse.type as WarehouseTypes];

  const [warehouseWithBags, setWarehouseWithBags] = useState<IWarehouseWithBags | null>(
    null,
  );
  const bags = bagFilter
    ? warehouseWithBags?.bags?.filter(bagFilter)
    : warehouseWithBags?.bags;

  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const onToggleIsOpen = () => setIsOpen((prev) => !prev);
  const onClickHandler = async () => {
    onToggleIsOpen();

    // @ts-ignore
    if (!warehouseWithBags) {
      setIsLoading(true);
      const data = await onLoadBags(warehouse.id);
      setWarehouseWithBags(data);
      setIsLoading(false);
    }
  };

  return (
    <Collapse
      className={rootClass}
      label={
        <div className={styles.label}>
          <span className={styles.label__name}>{warehouse.name}</span>

          <WarehouseTypeTag type={warehouse.type} />
          {/*<span className={styles.label__filledBags}>{warehouse.filledBags} шт</span>*/}
        </div>
      }
      isOpen={isOpen}
      onClick={onClickHandler}
    >
      {isLoading && <Loader />}

      {
        // @ts-ignore
        bags?.map((bag) => (
          <FilledBag
            key={bag.id}
            className={styles.bag}
            id={bag.id}
            bag={bag}
            type={warehouse.type === WarehouseTypes.Stationary ? 'bunker' : 'sleeve'}
            onClick={() => onSelectBag(bag, warehouse)}
          />
        ))
      }

      {!isLoading && !bags?.length && <div className={styles.empty}>Пусто</div>}
    </Collapse>
  );
}

export interface IWarehouseWithBagsCollapseProps {
  className?: string;
  warehouse: IWarehouse;
  bagFilter?: (bag: IBag) => boolean;

  onLoadBags: (
    id: IWarehouse['id'],
  ) => IWarehouseWithBags | Promise<IWarehouseWithBags>;
  onSelectBag: (bag: IBag, warehouse: IWarehouse) => void | Promise<void>;
}
